import { Link, useSearchParams } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { PageHeader } from '../ui/PageHeader';
import { btnPrimary } from '../ui/styles';
import { Marketing } from './Marketing';
import { BrandKit } from './BrandKit';
import { MarketingTabs } from './MarketingTabs';
type TabKey = 'ontwerpen' | 'merkstijl';
const titles: Record<TabKey, string> = {
  ontwerpen: 'Ontwerpen',
  merkstijl: 'Merkstijl & teksten'
};
const descriptions: Record<TabKey, string> = {
  ontwerpen: 'Posts, stories, flyers en kaarten in je eigen huisstijl. Pas de tekst, kleur en foto aan en download het bestand, of plan het direct in. Prijzen, adres en productfoto’s komen vanzelf uit de webshop.',
  merkstijl: 'Zo ziet Beauty Bewust eruit en zo klinkt het. Deel deze pagina met een drukker, fotograaf of iemand die je socials helpt: dan klopt alles met de website.'
};

/** /be/ontwerpen — de ontwerpen en de merkstijl (?tab=merkstijl); de tabrij deelt hij met de planner. */
export function Designs() {
  const [params] = useSearchParams();
  const tab: TabKey = params.get('tab') === 'merkstijl' ? 'merkstijl' : 'ontwerpen';
  return <div data-id="element-2982" data-mp="1wco3p1d04h4g">
      <PageHeader title={titles[tab]} description={descriptions[tab]} actions={tab === 'ontwerpen' ? <Link to="/be/ontwerpen/nieuw" className={btnPrimary} data-id="element-2984" data-mp="1mgl4o4dg4ylq">
              <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-2985" data-mp="1me8dd0lstbw0" />
              Nieuw ontwerp
            </Link> : undefined} data-id="element-2983" data-mp="1wc61lo3nr8om" />
      <MarketingTabs data-id="element-2986" data-mp="2f59yrjg343nz" />
      {tab === 'merkstijl' ? <BrandKit data-id="element-2987" data-mp="2a5no9hrn51iv" /> : <Marketing data-id="element-2988" data-mp="2a54dcl0erdec" />}
    </div>;
}